import _debounce2 from "lodash/debounce";
import React from 'react';
import PowerOffIcon from '@material-ui/icons/PowerOff';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import CSSclasses from './logout-widget.scss';
const LogoutWidget = ({
  logout,
  user
}) => /*#__PURE__*/React.createElement("div", {
  className: CSSclasses.container,
  "data-block": "LogoutWidget"
}, /*#__PURE__*/React.createElement("div", {
  className: CSSclasses.title
}, "You are currently browsing as ", /*#__PURE__*/React.createElement("div", {
  className: CSSclasses.email
}, user.email)), /*#__PURE__*/React.createElement(Tooltip, {
  title: "Logout and return to users list",
  placement: Placement.TOP
}, /*#__PURE__*/React.createElement("div", {
  "data-button": "LogoutAsUser",
  className: CSSclasses.button,
  onClick: _debounce2(logout, 500)
}, /*#__PURE__*/React.createElement(PowerOffIcon, null))));
export default LogoutWidget;